import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import AppWrapper from './AppWrapper';
import defaultApi from './api/defaultApi';
import { instalarSesion } from './seguridad/sesionCliente';

// Acceso de 15 min que se renueva solo (ADR-002 S2); se instala antes del primer render.
instalarSesion(defaultApi);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <HashRouter>
            <AppWrapper></AppWrapper>
        </HashRouter>
    </React.StrictMode>
);


